"use strict";

/****************
 MENU
 ****************/
var menu;

jQuery(document).ready(function ($) {
    menu = new Menu();
});

/****************
RADIO BUTTON FORM
 ****************/
jQuery(document).ready(function ($) {
    $(".js-form-type-radio label").append("<span></span>");

    /****************************
    FIX ISSUE SCROLLTOP ANIMATION
     ****************************/
    $('body,html').bind('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function (e) {
        if (e.which > 0 || e.type == "mousedown" || e.type == "mousewheel" || e.type == "touchmove") {
            $("html,body").stop();
        }
    });

    /*******
    SCROLLTO
     *******/
    $('a[href^=\\#]').each(function () {
        $(this).click(function (event) {

            event.preventDefault();

            var to = $.attr(this, 'href');
            if ($(to).offset()) {
                $('html, body').animate({
                    scrollTop: $(to).offset().top - 80
                }, 1200, 'easeInOutExpo', function () {});
            }
            return false;
        });
    });

    $('.paragraph a').click(function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: $(this).parents('.paragraph').height()
        }, 1200, 'easeInOutExpo');

        return false;
    });

    /******
    MIXITUP
     ******/
    if ($('.block-teaser.careers').length > 0) {
        $('.careers').mixItUp();
    }

    /********************************
    REMOVE BROUTGAASS BLOCK IF 2 NEWS
     ********************************/
    /*
    $('#block-small-news-block .news-teaser-container-inner').each(function() {
        var $this = $(this);
        var remove = $('.small-news .broutgaass');
        if ($this.children('div').length <= 1) {
            remove.show();
        }
    });
    */

    /************************
     PRODUCT APPEAR ON SCROLL
     ************************/
    $('.product-infos .products-teaser').appear();
    $('.product-infos .products-teaser').on('appear', function (event, $all_appeared_elements) {
        $($all_appeared_elements).addClass('appear');
    });
    $.force_appear();

    /*****************************************************
     ADD CLASS CAREERS CTA HOMEPAGE IF NO FEATURED PRODUCT
     *****************************************************/
    $('.homepage-promo-careers').each(function () {
        var $this = $(this);
        if ($('.featured-product').length == 1) {
            $this.addClass('two-block');
        } else {
            $this.addClass('one-block');
        }
    });

    /***************************
    OWL CAROUSEL HOMEPAGE - NEWS
     ***************************/
    $('.homepage-news-block .news').each(function () {
        if ($(this).children().length > 1) {
            $(this).owlCarousel({
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                items: 1,
                autoplay: false,
                autoplayTimeout: 5000,
                loop: true,
                nav: true,
                navText: true,
                responsive: {
                    0: {
                        nav: false
                    },
                    480: {
                        nav: false
                    }
                }
            });
        }
    });

    /***************************
     OWL CAROUSEL HOMEPAGE - NEWS
     ***************************/
    $('#block-featured-product .featured-row').each(function () {
        if ($(this).children().length > 1) {
            $(this).owlCarousel({
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                items: 1,
                autoplay: true,
                autoplayTimeout: 5000,
                loop: true
            });
        }
    });

    /******
     STICKY
     ******/
    var $window = $(window);

    function checkWidth() {
        if ($window.width() > 992) {
            jQuery(".path-taxonomy.path-regional .sticky-left-watcher .sticky, .path-taxonomy.path-international .sticky-left-watcher .sticky, .path-taxonomy .sticky-left-watcher .sticky").sticky({
                //getTopFrom:'#header',
                marginTop: 0,
                getBottomFrom: '#footer',
                marginBottom: 100,
                getWidthFrom: '.sticky-left-watcher',
                responsiveWidth: true,
                condition: function condition() {
                    return jQuery(window).width() >= 768 && !jQuery('html').hasClass('mobile');
                }
            });
        };
    }

    /*******************************************
     RESPONSIVE BOUTON RECHERCHE AVANCEE SIDEBAR
     *******************************************/
    jQuery('#block-productadvancedsearch a, #block-productadvancedsearchen a').click(function () {
        jQuery('.sidebar').toggleClass('open');
    });

    checkWidth();

    $(window).resize(checkWidth);

    /***********
     MATCHHEIGHT
     ***********/
    if ($('.matchheight').length) {
        $('.matchheight').matchHeight();
    }

    /*********
    GOOGLE MAP
     *********/
    if ($('#map').length > 0) {
        var initialize = function initialize() {

            var myLatLng = { lat: 49.659390 - 0.002, lng: 6.291120 };
            var isDraggable = jQuery(window).width() > 1024 ? true : false;

            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: 14,
                center: myLatLng,
                /*center: new google.maps.LatLng(49.659390-0.001, 6.291120-0.0002),*/
                scrollwheel: false,
                mapTypeControl: false,
                draggable: false
            });

            var icon = {
                url: '/themes/panelux/assets/images/panelux-logo-map.png',
                scaledSize: new google.maps.Size(75, 75),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 0)
            };

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: icon
            });

            var map = new google.maps.Map(document.getElementById("map"), map);
        };

        google.maps.event.addDomListener(window, 'load', initialize);
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    var region = getUrlParameter('region');

    if (region == 'international') {
        $('body').removeClass('international-only');
        $('body').removeClass('regional-only');

        $('body').addClass('international-only');
    }

    if (region == 'regional') {
        $('body').removeClass('international-only');
        $('body').removeClass('regional-only');

        $('body').addClass('regional-only');
    }
});
'use strict';

(function ($) {
    Drupal.behaviors.form = {
        attach: function attach(context, settings) {

            $('.webform-submission-form > form').validate({

                rules: {
                    civilite: {
                        required: true
                    },
                    a_quel_service_souhaitez_vous_vous_adresser_: {
                        required: true
                    }
                },

                highlight: function highlight(element) {
                    $(element).closest('.form-group').addClass('error');

                    $(element).closest('.form-select').addClass('error');

                    if (element.type === 'radio') {
                        $(element).parents().addClass('error');
                    }
                },

                unhighlight: function unhighlight(element) {
                    $(element).closest('.form-group').removeClass('error');

                    $(element).closest('.form-select').removeClass('error');

                    if (element.type === 'radio') {
                        $(element).parents().removeClass('error');
                    }
                },

                errorPlacement: function errorPlacement(error, element) {
                    return true;
                },

                focusInvalid: false,
                invalidHandler: function invalidHandler(form, validator) {

                    if (!validator.numberOfInvalids()) return;

                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element).offset().top - 200
                    }, 1200, 'easeInOutExpo');
                }

            });

            /*            $('.form-radio').each(function() {
                            $(this).rules('add', {
                                required: true,
                            });
                        });*/
        }

    };
})(jQuery);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Menu = function () {
    function Menu() {
        _classCallCheck(this, Menu);

        this.lastScrollTopBeforeOpenMenu = 0;
        this.evt = 'touchstart';
        if (navigator.msPointerEnabled || !('ontouchend' in window)) this.evt = "click";

        jQuery('#hamburger').on(this.evt, function (e) {
            if (jQuery('html').hasClass('hamburger-eaten')) {
                this.close();
            } else {
                this.open();
            }
        }.bind(this));

        /* RESPONSIVE */
        jQuery('#block-panelux-main-menu > ul > li:has(ul), .sidebar nav > ul > li:has(ul)').addClass('submenu');

        jQuery('#block-panelux-main-menu > ul > li.submenu > a, .sidebar nav > ul > li.submenu > a').click(function () {

            var has = jQuery(this).parent().hasClass('submenu-open');
            jQuery('#block-panelux-main-menu > ul > li > a, .sidebar nav > ul > li > a').parent().removeClass('submenu-open');

            if (has) {
                jQuery(this).parent().removeClass('submenu-open');
            } else {
                jQuery(this).parent().addClass('submenu-open');
            }

            return false;
        });

        jQuery('.sidebar nav > ul > li.submenu').each(function () {
            if (jQuery(this).hasClass('is-active')) {
                jQuery(this).addClass('submenu-open');
            }
        });
    }

    _createClass(Menu, [{
        key: 'open',
        value: function open() {
            this.lastScrollTopBeforeOpenMenu = jQuery(window).scrollTop();
            jQuery('html').addClass('hamburger-eaten');
        }
    }, {
        key: 'close',
        value: function close() {
            jQuery('html').addClass('hamburger-renew');
            jQuery('html').removeClass('hamburger-eaten');

            jQuery(window).scrollTop(this.lastScrollTopBeforeOpenMenu);

            setTimeout(function () {
                jQuery('html').removeClass('hamburger-renew');
            }, 1000);
        }
    }]);

    return Menu;
}();